import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { toast } from 'react-toastify';
import config from '../utils/config';

/**
 * The reCAPTCHA validation used on the public payment actions: it tries the invisible
 * challenge first and falls back to the regular one when it fails. Render
 * `recaptchaElement` on the form and call `getRecaptchaData` before the request, which
 * returns null when the customer could not be validated.
 */
export default function useRecaptcha() {
    const invisibleRef = useRef(null);
    const [token, setToken] = useState('');
    const [showNormalRecaptcha, setShowNormalRecaptcha] = useState(false);

    const getRecaptchaData = async () => {
        if (showNormalRecaptcha) {
            if (!token) {
                toast.error('Validação obrigatória');
                return null;
            }

            invisibleRef.current.reset();
            return { recaptchaToken: token, recaptchaType: 'normal' };
        }

        const timeoutId = setTimeout(() => {
            invisibleRef.current.reset();
            toast.warning('Verifique que você não é um robô.');
            setShowNormalRecaptcha(true);
        }, 15000);

        const invisibleToken = await invisibleRef.current.executeAsync();
        clearTimeout(timeoutId);
        invisibleRef.current.reset();

        if (!invisibleToken) {
            toast.warning('Verifique que você não é um robô.');
            setShowNormalRecaptcha(true);
            return null;
        }

        return { recaptchaToken: invisibleToken, recaptchaType: 'invisible' };
    }

    const recaptchaElement = (
        <>
            <ReCAPTCHA
                ref={invisibleRef}
                size="invisible"
                sitekey={config.SITE_KEY_REACAPTCHA_INVISIBLE}
            />

            {showNormalRecaptcha &&
                <ReCAPTCHA
                    sitekey={config.SITE_KEY_REACAPTCHA_NORMAL}
                    onChange={(value) => setToken(value)}
                    onErrored={() => setToken('')}
                    onExpired={() => setToken('')}
                />
            }
        </>
    );

    return { recaptchaElement, getRecaptchaData };
}
